import React, {useEffect, useState} from 'react'
import {Document, Page} from 'react-pdf'
import 'react-pdf/dist/esm/Page/AnnotationLayer.css'
import {CreateAgreementStep1DataType} from '../agreementDataType'

const CreateAgreementStep1 = ({
  templateData,
  propertyList,
  formik,
  acceptedFileItems,
  fileRejectionItems,
  getRootProps,
  getInputProps,
  isDragActive,
  acceptedFiles,
}: CreateAgreementStep1DataType) => {
  const [numPages, setNumPages] = useState<number>()
  const [pageNumber, setPageNumber] = useState<number>(1)

  // After changing template it will take to first page of new template
  useEffect(() => {
    setPageNumber(1)
  }, [formik.values.document_signing_template_uuid])

  // react-pdf code starts
  function onDocumentLoadSuccess({numPages}: {numPages: number}): void {
    setNumPages(numPages)
  }
  const handlePrevious = () => {
    setPageNumber((preval) => preval - 1)
  }
  const handleNext = () => {
    setPageNumber((preval) => preval + 1)
  }
  // react-pdf code ends

  // function for changing agreement
  const handleChangeAgreementType = (val: string) => {
    if (val === 'create') {
      acceptedFiles.pop()
    } else if (val === 'upload') {
      formik.setFieldValue('document_signing_template_uuid', '', true)
    }
    formik.setFieldValue('agreement_type', val, true)
  }

  return (
    <div className='card mb-5 mb-xl-10 w-100'>
      <div className='card-header border-0 d-flex justify-content-between align-items-center'>
        {/* Begin: heading */}
        <div className='card-title m-0'>
          <h3 className='fw-bolder m-0'>Basic Details</h3>
        </div>
        {/* End: heading */}
      </div>

      <div id='kt_account_profile_details' className='collapse show'>
        <div className='card-body border-top px-9 pt-9 pb-2'>
          {/* Begin: form field Property */}
          <div className='row mb-2'>
            <label className='col-lg-4 col-form-label fw-bold fs-6'>
              <span className='required'>Property</span>
              <i
                className='fas fa-exclamation-circle ms-2 fs-7'
                data-bs-toggle='tooltip'
                title='Choose property'
              ></i>
            </label>
            <div className='col-lg-8 fv-row'>
              <select
                className='form-select form-select-solid'
                {...formik.getFieldProps('property_uuid')}
                name='property_uuid'
                placeholder='Select property'
              >
                <option className='bg-color-gray' value=''>
                  Select property
                </option>
                {propertyList?.map((item) => {
                  return (
                    <option key={item.property_uuid} value={item.property_uuid}>
                      {item.property_title}
                    </option>
                  )
                })}
              </select>
              <div className='h-20px'>
                {formik.touched.property_uuid && formik.errors.property_uuid && (
                  <div className='fv-help-block color-red'>{formik.errors.property_uuid}</div>
                )}
              </div>
            </div>
          </div>
          {/* End: form field Property */}

          {/* Begin: form field agreement type */}
          <div className='row mb-2'>
            <div className='col-lg-6 my-1'>
              <input
                type='radio'
                {...formik.getFieldProps('agreement_type')}
                className='btn-check'
                name='agreement_type'
                value='create'
                id='agreement_type_create'
                checked={formik.values.agreement_type === 'create'}
                onChange={(e) => handleChangeAgreementType(e.target.value)}
              />
              <label
                className='btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center'
                htmlFor='agreement_type_create'
              >
                <i
                  className={`bi bi-ui-checks fs-1 me-5 ${
                    formik.values.agreement_type === 'create' && 'text-primary'
                  }`}
                ></i>
                <span className='d-block fw-bold text-start'>
                  <span className='text-dark fw-bolder d-block fs-4 mb-2'>
                    Choose from template
                  </span>
                  <span className='text-gray-400 fw-bold fs-6'>
                    Create agreement by providing details
                  </span>
                </span>
              </label>
            </div>
            <div className='col-lg-6 my-1'>
              <input
                type='radio'
                {...formik.getFieldProps('agreement_type')}
                className='btn-check'
                name='agreement_type'
                value='upload'
                id='agreement_type_upload'
                checked={formik.values.agreement_type === 'upload'}
                onChange={(e) => handleChangeAgreementType(e.target.value)}
              />
              <label
                className='btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center'
                htmlFor='agreement_type_upload'
              >
                <i
                  className={`bi bi-ui-checks fs-1 me-5 ${
                    formik.values.agreement_type === 'upload' && 'text-primary'
                  }`}
                ></i>
                <span className='d-block fw-bold text-start'>
                  <span className='text-dark fw-bolder d-block fs-4 mb-2'>Upload Agreement</span>
                  <span className='text-gray-400 fw-bold fs-6'>Upload your agreement</span>
                </span>
              </label>
            </div>

            <div className='h-20px'>
              {formik.touched.agreement_type && formik.errors.agreement_type && (
                <div className='fv-help-block color-red'>{formik.errors.agreement_type}</div>
              )}
            </div>
          </div>
          {/* Begin: form field agreement type */}

          {/*begin::Form Field agreement upload */}
          {formik.values.agreement_type === 'upload' && (
            <div className='fv-row'>
              <label className='d-flex fs-5 fw-semibold pb-1'>
                <span className=''>Agreement upload</span>
                <i
                  className='fas fa-exclamation-circle ms-2 fs-7'
                  data-bs-toggle='tooltip'
                  title='Upload agreement pdf'
                ></i>
              </label>
              <div className='d-flex justify-content-between'>
                {/*begin::Dropzone field */}
                <div
                  className={`border border-2 rounded border-dashed row p-1 bg-white mx-1 text-center w-100`}
                >
                  <section className='border border-2 rounded border-primary border-dashed h-100 symbol bg-light-primary'>
                    <div
                      {...getRootProps({
                        className:
                          'py-2 d-flex flex-column justify-content-center align-items-center',
                      })}
                    >
                      <input
                        {...getInputProps()}
                        {...formik.getFieldProps('file_data')}
                        name='file_data'
                      />
                      {isDragActive ? (
                        <p className='mb-1'>Drop the files here...</p>
                      ) : (
                        <p className='mb-1'>Drag and drop files here, or click to select files</p>
                      )}
                      <i className='bi bi-file-earmark-arrow-up-fill fs-3x btn btn-active-color-primary py-0 mb-1'></i>
                      <span className='text-primary fs-7'>Type: *.pdf only</span>
                      <span className='text-primary fs-7'>Max document:1</span>
                    </div>
                  </section>
                </div>
                {/*end::Dropzone field */}
              </div>
              <aside>
                {acceptedFileItems.length > 0 && (
                  <div className='p-2'>
                    <h4>Document is ready to upload</h4>
                    <ul>{acceptedFileItems}</ul>
                  </div>
                )}
                {fileRejectionItems.length > 0 && (
                  <div className='p-2'>
                    <span className='fv-help-block color-red'>
                      Upload only one file or select file with allowed format only
                    </span>
                    {/* <ul>{fileRejectionItems}</ul> */}
                  </div>
                )}
              </aside>
              <div className='h-20px'>
                {acceptedFileItems.length <= 0 &&
                  fileRejectionItems.length <= 0 &&
                  formik.touched.file_data &&
                  formik.errors.file_data && (
                    <div className='fv-help-block color-red'>{formik.errors.file_data}</div>
                  )}
              </div>
            </div>
          )}
          {/*end::Form Field agreement upload */}

          {/*begin::Form Field template type */}
          {formik.values.agreement_type === 'create' && (
            <div className='row'>
              {templateData &&
                templateData.map((template) => {
                  return (
                    <div className='col-lg-4 my-1'>
                      <input
                        type='radio'
                        {...formik.getFieldProps('document_signing_template_uuid')}
                        className='btn-check'
                        name='document_signing_template_uuid'
                        value={template.document_signing_template_uuid}
                        id={template.document_signing_template_uuid}
                        checked={
                          formik.values.document_signing_template_uuid ===
                          template.document_signing_template_uuid
                        }
                        onClick={() => window.open(template.document_link, '_blank')}
                      />
                      <label
                        className='btn btn-outline btn-outline-dashed btn-outline-default p-3 d-flex align-items-center'
                        htmlFor={template.document_signing_template_uuid}
                      >
                        <i
                          className={`bi bi-filetype-pdf fs-1 me-2 ${
                            formik.values.document_signing_template_uuid ===
                              template.document_signing_template_uuid && 'text-primary'
                          }`}
                        ></i>
                        <span className='text-dark fw-bolder d-block fs-6 mb-2'>
                          {template.document_signing_template_name}
                        </span>
                      </label>
                    </div>
                  )
                })}

              <div className='h-20px'>
                {formik.touched.document_signing_template_uuid &&
                  formik.errors.document_signing_template_uuid && (
                    <div className='fv-help-block color-red'>
                      {formik.errors.document_signing_template_uuid}
                    </div>
                  )}
              </div>
            </div>
          )}
          {/*End::Form Field template type */}
        </div>
      </div>

      {/*begin::Form Field template pdf */}
      {/* {formik.values.agreement_type === 'create' && formik.values.document_signing_template_uuid && (
        <div className='w-100 overflow-auto d-flex flex-column justify-content-center align-items-center container position-relative border border-primary border-dashed border-1 rounded p-2'>
          <Document
            file='\media\misc\sample1.pdf'
            onLoadSuccess={onDocumentLoadSuccess}
          >
            <Page
              pageNumber={pageNumber}
              loading={<div style={{height: '20px'}}>PDF is Loading</div>}
              noData='Annotations are disabled for this page'
              renderTextLayer={false}
            />
          </Document>
          {numPages && numPages > 1 && (
            <div className='d-flex w-100 justify-content-center sticky-bottom'>
              <span className='mt-1'>
                <button
                  className='btn p-1 text-primary bg-secondary rounded-left px-5'
                  disabled={pageNumber <= 1}
                  onClick={handlePrevious}
                >
                  {`< Previous`}
                </button>
                <span className='btn p-1 bg-secondary rounded px-5 mx-5'>
                  Page {pageNumber} of {numPages}
                </span>
                <button
                  className='btn p-1 text-primary bg-secondary rounded-right px-5'
                  disabled={pageNumber === numPages}
                  onClick={handleNext}
                >
                  {`Next >`}
                </button>
              </span>
            </div>
          )}
        </div>
      )} */}
      {/*end::Form Field template pdf */}
    </div>
  )
}

export default CreateAgreementStep1
